export default __webpack_public_path__ + "static/media/leo.64049484.jpg";